import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {ICharBloodMagicItem} from "../../_interfaces/ICharBloodMagicItem";
import {s_char_bloodmagicitems} from "../../_signals/s_char";
import {BloodMagicItemUpdate} from "../../_api/BEBloodMagicItems";
import {IDataBloodmagicItem} from "../../_interfaces/IDataBloodmagicItem";
import bloodmagic_items from "../../_data/bloodmagic_items";

interface IProp {
    open: ICharBloodMagicItem | null,
    isOpen: (open: boolean) => void
}

export default function BloodMagicItemsEdit({open, isOpen}: IProp) {

    const descrRef = useRef<HTMLInputElement>(null);
    const [itemstate, setItemState] = useState(0)
    const [itemData, setItemData] = useState<IDataBloodmagicItem | null>(null)

    useEffect(() => {
        if (open) {
            const item = bloodmagic_items.find(i => i.name === open?.name)
            setItemData(item ?? null)
            setItemState(open.state)
        }
    }, [open])

    const save = () => {
        if (!open) return

        open.descr = descrRef.current?.value ?? '';
        open.state = itemstate;

        let items = s_char_bloodmagicitems.value
        items = items.map(i => {
            if (i.id === open.id) {
                BloodMagicItemUpdate(i)
                return open
            }
            return i
        })
        s_char_bloodmagicitems.value = items

        isOpen(false)
    }

    return <Dialog open={!!open}>
        <DialogContent>
            {open?.name}
            <TextField defaultValue={open?.descr}
                       label={'Beschreibung'}
                       inputRef={descrRef}
                       variant="standard"
                       style={{width: '100%'}}
            />
            <Select value={itemstate || 0}
                    style={{width: "100%"}}
                    onChange={(e) => setItemState(e.target.value as number)}
            >
                <MenuItem key={v4()} value="0">ungebunden</MenuItem>
                <MenuItem key={v4()} value="1">gebunden</MenuItem>
                <MenuItem key={v4()} value="2">benutzt</MenuItem>
            </Select>
            {itemData ?
                <>
                    <div>{itemData.desc}</div>
                    <div>Schaden: {itemData.dmg}</div>
                    <div>{itemData.avail}</div>
                </>

                : null}
            {itemData && itemData.strain_mods ?
                itemData.strain_mods.map(sm =>
                    <>
                        <div>{sm.what}</div>
                        <div>{sm.mod}</div>
                        <div>{sm.type}</div>
                        <div>{sm.duration}</div>
                    </>
                )
                : null}
        </DialogContent>
        <DialogActions>
            <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
            <Button className={'btn'} id="post" onClick={() => isOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>

}
